/**
 * 客服工作台参与店铺：默认全部加入；用户可移出，也可再加回来。
 * 用「移出列表」存储，新授权的店会自动进工作台。
 */
const STORAGE_KEY = "kefu.smartReply.deskExcludedShopIds";

export function loadDeskExcludedShopIds() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const arr = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(arr)) return [];
        return Array.from(
            new Set(arr.map((x) => String(x || "").trim()).filter(Boolean))
        );
    } catch (e) {
        return [];
    }
}

export function saveDeskExcludedShopIds(ids) {
    const list = Array.from(
        new Set((ids || []).map((x) => String(x || "").trim()).filter(Boolean))
    );
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    return list;
}

export function filterDeskShops(shops, excludedIds) {
    const ex = new Set((excludedIds || []).map(String));
    return (shops || []).filter((s) => s && s.id != null && !ex.has(String(s.id)));
}

export function isShopOnDesk(shopId, excludedIds) {
    const id = String(shopId || "");
    if (!id) return false;
    return !(excludedIds || []).map(String).includes(id);
}
